import * as React from 'react';
/**
 * Context which holds the required helpers needed to build nested navigators.
 */
var NavigationBuilderContext = /*#__PURE__*/React.createContext({
  onDispatchAction: function onDispatchAction() {
    return undefined;
  },
  onOptionsChange: function onOptionsChange() {
    return undefined;
  }
});
export default NavigationBuilderContext;